import { gql, useMutation } from '@apollo/client'
import { useNotification } from '@btime/react-messager'

import { accountsClient } from '../../../../utils/apollo/api'

const MUTATION = gql`
  mutation UpsertUserGroup($input: UserGroupInput) {
    upsertUserGroup(input: $input) {
      id
      name
    }
  }
`

export const useSaveUserGroup = onSuccess => {
  const notify = useNotification()
  const [request, state] = useMutation(MUTATION, { refetchQueries: ['UserGroups'], client: accountsClient })

  const handleRequest = name => {
    const input = { name }

    return request({ variables: { input } }).then(resp => {
      if (!resp.errors) {
        if (!!onSuccess) onSuccess(resp.data?.upsertUserGroup)
      } else {
        notify.error({ title: 'Ocorreu um erro ao salvar!' })
      }
    })
  }

  return [handleRequest, state]
}
